import { useAuth0 } from '@auth0/auth0-react'
import Spinning from 'components/Common/Spinner/Spinning'
import React from 'react'
import './Logout.scss'

export const Logout = () => {
  const { logout } = useAuth0()

  React.useEffect(() => {
    logout({
      returnTo: window.location.origin,
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <div className="logout-page">
      <Spinning />
    </div>
  )
}
